"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyFolder = void 0;
var React = require("react");
var Icon_1 = require("components/Icon");
require("./style.scss");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var EmptyFolder = function (props) { return (React.createElement("div", { className: 'file-list-empty-folder' },
    React.createElement("div", { className: 'circle' }, props.icon || React.createElement(Icon_1.Icon, { className: "fa-file-alt" })),
    React.createElement("b", null, props.title === undefined
        ? (0, translation_1.getLocalization)('components/folder/empty')
        : props.title),
    React.createElement("span", null, props.content === undefined
        ? (0, translation_1.getLocalization)('components/folder/dragndrop')
        : props.content))); };
exports.EmptyFolder = EmptyFolder;
